export default __webpack_public_path__ + "static/media/binoculars.2f401fa6.svg";